import { createFileRoute } from '@tanstack/react-router';
import { RenegociacaoEdicao } from '@/features/renegociacao/page/edicao/RenegociacaoEdicao';

function Component() {
    return <RenegociacaoEdicao isPagar={true} />;
}

export const Route = createFileRoute('/a/renegociacao/contas-pagar/cadastrar')({
    component: Component,
});
